/**
 * OracleLandingPage
 * Oracle giriş sayfası - Premium açılış
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import OracleShell from '../components/OracleShell';

export default function OracleLandingPage({ credits }) {
  const navigate = useNavigate();
  
  const handleStart = () => {
    navigate('/oracle/new');
  };
  
  return (
    <OracleShell credits={credits}>
      <div className="oracle-content oracle-landing">
        {/* Logo */}
        <div className="oracle-logo">🔮</div>
        
        {/* Title */}
        <h1 className="oracle-title">MysticAI Oracle</h1>
        
        {/* Description */}
        <p className="oracle-description">
          Kahve fincanındaki semboller; Tarot, Katina ve sezgisel anlatı katmanlarıyla 
          sana özel tek bir açılımda birleşiyor.
        </p>
        
        {/* Main Card */}
        <div 
          className="oracle-glass-card oracle-main-card"
          onClick={handleStart}
          data-testid="start-oracle-btn"
        >
          <div className="oracle-main-card-icon">☕</div>
          <h2 className="oracle-main-card-title">Fincanını Yerleştir</h2>
          <p className="oracle-main-card-subtitle">
            Niyetini seç ve MysticAI Oracle&apos;ın semboller arasındaki hikâyeyi ortaya çıkarmasına izin ver.
          </p>
          
          {/* Duration */}
          <div style={{ fontSize: 13, color: 'var(--oracle-text-muted)', marginBottom: 16 }}>
            Yaklaşık 60 saniye sürer
          </div>
          
          {/* Badge */}
          <div className="oracle-gold-badge">
            ✨ Oracle Experience
          </div>
        </div>
      </div>
    </OracleShell>
  );
}
